var exports = {
  "kL": "xa15a2ab7--2e63b1--container",
  "MR": "xa15a2ab7--2e63b1--sms-container",
  "DD": "xa15a2ab7--2e63b1--title",
  "dk": "xa15a2ab7--2e63b1--label-comment",
  "ep": "xa15a2ab7--2e63b1--comment-text",
  "PC": "xa15a2ab7--2e63b1--textarea",
  "Pf": "xa15a2ab7--2e63b1--label",
  "lB": "xa15a2ab7--2e63b1--span-columns",
  "ZZ": "xa15a2ab7--2e63b1--field",
  "H4": "xa15a2ab7--2e63b1--child-types-container",
  "tA": "xa15a2ab7--2e63b1--submit",
  "VT": "xa15a2ab7--2e63b1--submit-container",
  "z3": "xa15a2ab7--2e63b1--error",
  "QZ": "xa15a2ab7--2e63b1--sms-code",
  "AP": "xa15a2ab7--2e63b1--seconds-left",
  "Eu": "xa15a2ab7--2e63b1--send-code-again",
  "kb": "xa15a2ab7--2e63b1--term-description",
  "NF": "xa15a2ab7--2e63b1--label-invalid",
  "nf": "xa15a2ab7--2e63b1--link",
  "RC": "xa15a2ab7--2e63b1--preloader",
};

module.exports = exports;
